import asyncSweetScroll from '@/helpers/sweet_scroll';

$(document).on('turbolinks:load', () => {
  $('.red_headline .learn-more').on('click', () => {
    asyncSweetScroll('#red_headline_scroll_target');
  });
});
